import script from "./NetworkStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./NetworkStatus.vue?vue&type=script&setup=true&lang=js"

import "./NetworkStatus.vue?vue&type=style&index=0&id=5ff00232&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff00232"]])

export default __exports__